import styled from 'styled-components';

import Button, {ActionButton} from '~/shared/components/Button';
import {media, flipOnLTR, rotateOnLTR} from '~/shared/theme/utils';
import {body14Normal, body20Bold} from '~/shared/theme/typography';
import BackIconComponent from '~/assets/images/svgIconsAsText/mobile_back.svg?react';
import {flexColumn, flexColumnCenterVertically} from '~/shared/theme/FlexLayout';

export const AddressDropdownButton = styled(Button)`
  display: block;
  transition: opacity 0.25s;
  z-index: 1;

  &:hover {
    opacity: 0.9;
  }

  &:disabled {
    cursor: no-drop;
  }

  &:active {
    opacity: 0.5;
  }
`;
export const BackIcon = styled(BackIconComponent)`
  color: ${({theme}) => theme.colors.gray000};
  top: 2px;
  ${flipOnLTR`
    left: -17px;
  `}

  ${media.minTablet`
    ${flipOnLTR`
      left: auto;
    `}
  `};
  ${rotateOnLTR}
`;

export const BlockHeader = styled.div`
  display: flex;
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.3);
  background: ${({theme}) => theme.colors.surface};
  width: 100%;
  position: absolute;
  top: -70px;
  z-index: 2;
  height: 70px;
  ${media.minTablet`
    border-bottom: 0;
    background: initial;
    width: auto;
    position: relative;
    top: auto;
    z-index: initial;
    padding: 10px 20px;
  `};
`;

export const TitleText = styled.label.attrs({
  tabIndex: 0,
})`
  ${body20Bold};
  ${flexColumnCenterVertically};
  flex: 1;
  text-align: center;
  padding: 5px 0 0;
  color: ${({theme}) => theme.addressDropdown.form.titleColor};
  line-height: 22px;
  letter-spacing: 0.5px;
`;

export const FormContainer = styled.div`
  ${flexColumn};
  padding: 15px 20px;
  color: ${({theme}) => theme.addressDropdown.form.textColor};

  textarea {
    width: 100%;
    padding: 5px;
  }

  .react-autosuggest__container {
    width: 100%;
  }
`;

export const FormText = styled.div`
  ${body14Normal};
  line-height: 14px;
  text-align: center;
  margin-bottom: 20px;
  color: ${({theme}) => theme.addressDropdown.form.textColor};
`;

export const ButtonBar = styled.div`
  justify-content: ${({center}) => (center ? 'center' : 'space-between')};
  display: flex;
  height: 85px;
  padding: 15px 15px 20px 15px;
  margin-top: auto;
  ${media.minMobile`
    padding: 15px 25px 20px 25px;
  `};
  ${({nopadding}) => nopadding && 'padding: 0;'}
`;

export const AddAddressActionButton = styled(ActionButton)`
  flex: 1;
  padding: 0 10px;
  box-shadow: ${({theme}) => theme.shadows.shadow2};
  border: inherit;
  ${media.minTablet`
    padding: 0px 32px;
  `}

  &&:hover {
    opacity: 0.9;
    background-color: ${({theme, reverseColors}) =>
    (reverseColors ? theme.actionButton.enabled.color : theme.actionButton.enabled.hoverBg)};
  }

  &:active {
    opacity: 0.5;
  }
`;
